"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const _package = require("../package.json.cjs");
const devMsg = (slug) => {
  return `https://prismic.dev/msg/react/v${_package.version}/${slug}`;
};
exports.devMsg = devMsg;
//# sourceMappingURL=devMsg.cjs.map
